/**
 * 路由工具函数
 * 包含共享的路由匹配和判断逻辑
 */

import { publicRoutes, protectedRoutes } from '@/config/routes';
/**
 * 检查路径是否匹配路由模式（支持通配符*）
 * @param pathname 当前路径
 * @param routePattern 路由模式
 * @returns 是否匹配
 */
export function matchRoute(pathname: string, routePattern: string): boolean {
    if (routePattern === pathname) {
        return true;
    }

    // 处理带通配符的路由模式，确保 "/inventories/*" 只匹配 "/inventories" 以及以 "/inventories/" 开头的路径
    const basePath = routePattern.replace(/\/\*$/, '').replace(/\*$/, '');
    const isMatch =
        pathname === basePath || pathname.startsWith(`${basePath}/`);
    return isMatch;
}

/**
 * 检查路径是否匹配任何受保护的路由
 * @param pathname 当前路径
 * @returns 是否为受保护路由
 */
export function isProtectedRoute(pathname: string): boolean {
    const isProtected = protectedRoutes.some(route =>
        matchRoute(pathname, route),
    );
    return isProtected;
}

/**
 * 检查路径是否匹配任何公开的路由
 * @param pathname 当前路径
 * @returns 是否为公开路由
 */
export function isPublicRoute(pathname: string): boolean {
    const isPublic = publicRoutes.some(route => matchRoute(pathname, route));
    return isPublic;
}
